import { useQuery, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { Contact, School } from 'types/school';
import { Schoolyear } from 'types/schoolyear';
import { LivretEval, Periode } from 'containers/Livrets/types/livret';
import { Bo } from 'types/bo';
import { Classroom } from 'types/classroom';
import { getNotationsHelperAttributes } from 'containers/CarnetsDeNotes/Evaluations/utils/getNotationsHelperAttributes';
import { deserializeEleve } from 'queries/eleves/serializer';
import { deserializePeriode } from 'containers/Livrets/queries/usePeriodes';
import { Eleve } from 'types/eleves';
import livretKeys from 'containers/Livrets/queries/keys';

interface GetShare {
  school: School;
  schoolyear: Schoolyear;
  livretEval: LivretEval;
  periodes: Periode[];
  directors: Contact[];
  classroom: Classroom;
  eleves: Eleve[];
  readonly?: boolean;
  bo: Bo;
  tz: string;
}

function fetch({ userId, token }: { userId: string; token: string }) {
  const requestURL = `/shares/${userId}/livrets/${token}`;
  return request(requestURL, {
    method: 'GET',
  }).then<GetShare>(data => {
    const notSystem = data.livretEval.notationSystem;
    return {
      ...data,
      livretEval: {
        ...data.livretEval,
        notationSystem: {
          ...notSystem,
          ...getNotationsHelperAttributes(notSystem),
        },
      },
      eleves: data.eleves.map(ev => deserializeEleve(ev, data.tz)),
      periodes: data.periodes.map(p => deserializePeriode(p, data.tz)),
    };
  });
}

export function useGetShareLivret(userId: string, token: string) {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ['test'],
    queryFn: () =>
      fetch({
        userId,
        token,
      }).then(data => {
        queryClient.setQueryData<LivretEval>(
          livretKeys.livretDetail(
            data.schoolyear.id,
            data.school.id,
            data.livretEval.id,
          ),
          data.livretEval,
        );
        return data;
      }),
    refetchOnWindowFocus: false,
    retry: (failCount, err) => {
      if (err?.response?.status === 404) {
        return false;
      }
      return failCount < 1;
    },
  });
}
